export default {
    zh: {
        hero_title: 'WeryAI Blog',
        hero_subtitle:
            '聚焦 AI 图像与视频创作，提供可复用的提示词、模型评测和生产工作流。',
        hero_badge: 'AI 创作洞察',
        hero_cta_primary: '阅读精选文章',
        hero_cta_secondary: '浏览最新文章',
        hero_visual_caption: '本周推荐',
        featured_hint: '模型评测、提示词模板与可落地工作流',
        featured_posts: '精选文章',
        recent_posts: '最新文章',
        all_categories: '全部分类',
        load_more: '加载更多',
        no_posts: '当前分类下暂无文章',
        read_more: '阅读全文',
        min_read: '分钟阅读',
        updated_label: '更新于',
        published_label: '发布于',
        back_to_blog: '返回 Blog',
        related_posts: '相关文章',
        categories: {
            'prompt-guides': '提示词指南',
            'model-reviews': '模型评测',
            comparisons: '模型对比',
            workflows: '工作流实战',
        },
        seo: {
            index_title: 'WeryAI Blog | AI 视频与图像创作指南',
            index_description:
                'WeryAI Blog 提供 AI 视频与图像创作指南，覆盖提示词、模型评测、对比分析和实战工作流。',
            index_keywords:
                'WeryAI Blog,AI 视频,AI 图像,提示词,模型评测,工作流',
        },
    },
    en: {
        hero_title: 'WeryAI Blog',
        hero_subtitle:
            'Practical guides for AI image and video creation: prompts, model reviews, and production workflows.',
        hero_badge: 'AI Creative Insights',
        hero_cta_primary: 'Read Featured Story',
        hero_cta_secondary: 'Browse Recent Posts',
        hero_visual_caption: 'Weekly Pick',
        featured_hint: 'Model reviews, prompt templates, and production playbooks',
        featured_posts: 'Featured Posts',
        recent_posts: 'Recent Posts',
        all_categories: 'All Categories',
        load_more: 'Load More',
        no_posts: 'No posts in this category yet',
        read_more: 'Read More',
        min_read: 'min read',
        updated_label: 'Updated',
        published_label: 'Published',
        back_to_blog: 'Back to Blog',
        related_posts: 'Related Posts',
        categories: {
            'prompt-guides': 'Prompt Guides',
            'model-reviews': 'Model Reviews',
            comparisons: 'Comparisons',
            workflows: 'Workflows',
        },
        seo: {
            index_title: 'WeryAI Blog | AI Video and Image Creation Guides',
            index_description:
                'Read WeryAI Blog for AI video and image tutorials, prompt frameworks, model comparisons, and production workflows.',
            index_keywords:
                'WeryAI Blog,AI video,AI image,prompt guide,model review,workflow',
        },
    },
    ja: {
        hero_title: 'WeryAI Blog',
        hero_subtitle:
            'AI 画像・動画制作のための実践ガイド。プロンプト、モデル比較、制作フローを解説します。',
        hero_badge: 'AI クリエイティブインサイト',
        hero_cta_primary: '注目記事を読む',
        hero_cta_secondary: '最新記事を見る',
        hero_visual_caption: '今週のピック',
        featured_hint: 'モデル比較、プロンプトテンプレート、実務フローを厳選',
        featured_posts: '注目記事',
        recent_posts: '最新記事',
        all_categories: 'すべてのカテゴリ',
        load_more: 'もっと見る',
        no_posts: 'このカテゴリにはまだ記事がありません',
        read_more: '続きを読む',
        min_read: '分で読めます',
        updated_label: '更新日',
        published_label: '公開日',
        back_to_blog: 'Blog に戻る',
        related_posts: '関連記事',
        categories: {
            'prompt-guides': 'プロンプトガイド',
            'model-reviews': 'モデルレビュー',
            comparisons: '比較',
            workflows: 'ワークフロー',
        },
        seo: {
            index_title: 'WeryAI Blog | AI 動画・画像制作ガイド',
            index_description:
                'WeryAI Blog では AI 動画と画像制作に役立つプロンプト、モデル比較、実務ワークフローを紹介します。',
            index_keywords:
                'WeryAI Blog,AI動画,AI画像,プロンプト,モデル比較,ワークフロー',
        },
    },
    ko: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'AI 이미지·동영상 제작을 위한 실용 가이드: 프롬프트, 모델 리뷰, 제작 워크플로.',
        hero_badge: 'AI 크리에이티브 인사이트',
        hero_cta_primary: '추천 글 읽기',
        hero_cta_secondary: '최신 글 보기',
        hero_visual_caption: '이번 주 추천',
        featured_hint: '모델 리뷰, 프롬프트 템플릿, 제작 플레이북',
        featured_posts: '추천 글',
        recent_posts: '최신 글',
        all_categories: '전체 카테고리',
        load_more: '더 보기',
        no_posts: '이 카테고리에 아직 글이 없습니다',
        read_more: '더 읽기',
        min_read: '분 읽기',
        updated_label: '업데이트',
        published_label: '게시일',
        back_to_blog: 'Blog로 돌아가기',
        related_posts: '관련 글',
        categories: {
            'prompt-guides': '프롬프트 가이드',
            'model-reviews': '모델 리뷰',
            comparisons: '비교',
            workflows: '워크플로',
        },
        seo: {
            index_title: 'WeryAI Blog | AI 동영상·이미지 제작 가이드',
            index_description: 'WeryAI Blog에서 AI 동영상·이미지 튜토리얼, 프롬프트, 모델 비교, 제작 워크플로를 확인하세요.',
            index_keywords: 'WeryAI Blog,AI 동영상,AI 이미지,프롬프트 가이드,모델 리뷰,워크플로',
        },
    },
    tw: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: '聚焦 AI 圖像與影片創作，提供可複用的提示詞、模型評測與生產工作流。',
        hero_badge: 'AI 創作洞察',
        hero_cta_primary: '閱讀精選文章',
        hero_cta_secondary: '瀏覽最新文章',
        hero_visual_caption: '本週推薦',
        featured_hint: '模型評測、提示詞範本與可落地工作流',
        featured_posts: '精選文章',
        recent_posts: '最新文章',
        all_categories: '全部分類',
        load_more: '載入更多',
        no_posts: '目前分類下暫無文章',
        read_more: '閱讀全文',
        min_read: '分鐘閱讀',
        updated_label: '更新於',
        published_label: '發佈於',
        back_to_blog: '返回 Blog',
        related_posts: '相關文章',
        categories: {
            'prompt-guides': '提示詞指南',
            'model-reviews': '模型評測',
            comparisons: '模型對比',
            workflows: '工作流實戰',
        },
        seo: {
            index_title: 'WeryAI Blog | AI 影片與圖像創作指南',
            index_description: 'WeryAI Blog 提供 AI 影片與圖像創作指南，涵蓋提示詞、模型評測、對比分析與實戰工作流。',
            index_keywords: 'WeryAI Blog,AI 影片,AI 圖像,提示詞,模型評測,工作流',
        },
    },
    es: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Guías prácticas para creación de imágenes y vídeos con IA: prompts, reseñas de modelos y flujos de producción.',
        hero_badge: 'Ideas creativas IA',
        hero_cta_primary: 'Leer artículo destacado',
        hero_cta_secondary: 'Ver publicaciones recientes',
        hero_visual_caption: 'Recomendación semanal',
        featured_hint: 'Reseñas de modelos, plantillas de prompts y guías de producción',
        featured_posts: 'Artículos destacados',
        recent_posts: 'Publicaciones recientes',
        all_categories: 'Todas las categorías',
        load_more: 'Cargar más',
        no_posts: 'Aún no hay publicaciones en esta categoría',
        read_more: 'Leer más',
        min_read: 'min de lectura',
        updated_label: 'Actualizado',
        published_label: 'Publicado',
        back_to_blog: 'Volver al Blog',
        related_posts: 'Artículos relacionados',
        categories: {
            'prompt-guides': 'Guías de prompts',
            'model-reviews': 'Reseñas de modelos',
            comparisons: 'Comparativas',
            workflows: 'Flujos de trabajo',
        },
        seo: {
            index_title: 'WeryAI Blog | Guías de creación de vídeo e imagen con IA',
            index_description: 'Lee WeryAI Blog para tutoriales de vídeo e imagen con IA, marcos de prompts, comparativas de modelos y flujos de producción.',
            index_keywords: 'WeryAI Blog,vídeo IA,imagen IA,guía de prompts,reseña de modelos,flujo de trabajo',
        },
    },
    fr: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Guides pratiques pour la création d’images et de vidéos IA : prompts, revues de modèles et flux de production.',
        hero_badge: 'Insights créatifs IA',
        hero_cta_primary: 'Lire l’article à la une',
        hero_cta_secondary: 'Voir les articles récents',
        hero_visual_caption: 'Sélection de la semaine',
        featured_hint: 'Revues de modèles, modèles de prompts et guides de production',
        featured_posts: 'Articles à la une',
        recent_posts: 'Articles récents',
        all_categories: 'Toutes les catégories',
        load_more: 'Charger plus',
        no_posts: 'Aucun article dans cette catégorie pour le moment',
        read_more: 'Lire la suite',
        min_read: 'min de lecture',
        updated_label: 'Mis à jour',
        published_label: 'Publié',
        back_to_blog: 'Retour au Blog',
        related_posts: 'Articles connexes',
        categories: {
            'prompt-guides': 'Guides de prompts',
            'model-reviews': 'Revues de modèles',
            comparisons: 'Comparaisons',
            workflows: 'Flux de travail',
        },
        seo: {
            index_title: 'WeryAI Blog | Guides de création vidéo et image IA',
            index_description: 'Consultez WeryAI Blog pour des tutoriels vidéo et image IA, des cadres de prompts, des comparaisons de modèles et des flux de production.',
            index_keywords: 'WeryAI Blog,vidéo IA,image IA,guide de prompts,revue de modèles,flux de travail',
        },
    },
    de: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Praktische Anleitungen für KI-Bilder und -Videos: Prompts, Modellbewertungen und Produktions-Workflows.',
        hero_badge: 'KI-Kreative Einblicke',
        hero_cta_primary: 'Empfohlener Artikel lesen',
        hero_cta_secondary: 'Neueste Artikel ansehen',
        hero_visual_caption: 'Empfehlung der Woche',
        featured_hint: 'Modellbewertungen, Prompt-Vorlagen und Produktionsleitfäden',
        featured_posts: 'Empfohlene Artikel',
        recent_posts: 'Neueste Artikel',
        all_categories: 'Alle Kategorien',
        load_more: 'Mehr laden',
        no_posts: 'In dieser Kategorie gibt es noch keine Artikel',
        read_more: 'Weiterlesen',
        min_read: 'Min. Lesezeit',
        updated_label: 'Aktualisiert',
        published_label: 'Veröffentlicht',
        back_to_blog: 'Zurück zum Blog',
        related_posts: 'Verwandte Artikel',
        categories: {
            'prompt-guides': 'Prompt-Leitfäden',
            'model-reviews': 'Modellbewertungen',
            comparisons: 'Vergleiche',
            workflows: 'Workflows',
        },
        seo: {
            index_title: 'WeryAI Blog | KI-Video- und Bild-Erstellungsleitfäden',
            index_description: 'Lesen Sie den WeryAI Blog für KI-Video- und Bild-Tutorials, Prompt-Rahmen, Modellvergleiche und Produktions-Workflows.',
            index_keywords: 'WeryAI Blog,KI-Video,KI-Bild,Prompt-Leitfaden,Modellbewertung,Workflow',
        },
    },
    ru: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Практические руководства по созданию изображений и видео с ИИ: промпты, обзоры моделей и рабочие процессы.',
        hero_badge: 'ИИ творческие идеи',
        hero_cta_primary: 'Читать избранную статью',
        hero_cta_secondary: 'Смотреть новые статьи',
        hero_visual_caption: 'Выбор недели',
        featured_hint: 'Обзоры моделей, шаблоны промптов и рабочие процессы',
        featured_posts: 'Избранные статьи',
        recent_posts: 'Новые статьи',
        all_categories: 'Все категории',
        load_more: 'Загрузить ещё',
        no_posts: 'В этой категории пока нет статей',
        read_more: 'Читать далее',
        min_read: 'мин чтения',
        updated_label: 'Обновлено',
        published_label: 'Опубликовано',
        back_to_blog: 'Назад к блогу',
        related_posts: 'Похожие статьи',
        categories: {
            'prompt-guides': 'Руководства по промптам',
            'model-reviews': 'Обзоры моделей',
            comparisons: 'Сравнения',
            workflows: 'Рабочие процессы',
        },
        seo: {
            index_title: 'WeryAI Blog | Руководства по созданию видео и изображений с ИИ',
            index_description: 'Читайте WeryAI Blog для уроков по видео и изображениям с ИИ, промптам, сравнению моделей и рабочим процессам.',
            index_keywords: 'WeryAI Blog,ИИ видео,ИИ изображения,промпт,обзор моделей,рабочий процесс',
        },
    },
    pl: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Praktyczne przewodniki po tworzeniu obrazów i wideo AI: prompty, recenzje modeli i przepływy produkcji.',
        hero_badge: 'Twórcze insighty AI',
        hero_cta_primary: 'Czytaj polecany artykuł',
        hero_cta_secondary: 'Przeglądaj najnowsze',
        hero_visual_caption: 'Polecenie tygodnia',
        featured_hint: 'Recenzje modeli, szablony promptów i przewodniki produkcji',
        featured_posts: 'Polecane artykuły',
        recent_posts: 'Najnowsze artykuły',
        all_categories: 'Wszystkie kategorie',
        load_more: 'Załaduj więcej',
        no_posts: 'W tej kategorii nie ma jeszcze artykułów',
        read_more: 'Czytaj więcej',
        min_read: 'min czytania',
        updated_label: 'Zaktualizowano',
        published_label: 'Opublikowano',
        back_to_blog: 'Powrót do bloga',
        related_posts: 'Powiązane artykuły',
        categories: {
            'prompt-guides': 'Przewodniki po promptach',
            'model-reviews': 'Recenzje modeli',
            comparisons: 'Porównania',
            workflows: 'Przepływy pracy',
        },
        seo: {
            index_title: 'WeryAI Blog | Przewodniki po wideo i obrazach AI',
            index_description: 'Czytaj WeryAI Blog po tutoriale wideo i obrazów AI, ramy promptów, porównania modeli i przepływy produkcji.',
            index_keywords: 'WeryAI Blog,wideo AI,obraz AI,przewodnik promptów,recenzja modeli,przepływ pracy',
        },
    },
    pt: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Guias práticos para criação de imagens e vídeos com IA: prompts, análises de modelos e fluxos de produção.',
        hero_badge: 'Insights criativos IA',
        hero_cta_primary: 'Ler artigo em destaque',
        hero_cta_secondary: 'Ver publicações recentes',
        hero_visual_caption: 'Recomendação da semana',
        featured_hint: 'Análises de modelos, modelos de prompts e fluxos de produção',
        featured_posts: 'Artigos em destaque',
        recent_posts: 'Publicações recentes',
        all_categories: 'Todas as categorias',
        load_more: 'Carregar mais',
        no_posts: 'Ainda não há publicações nesta categoria',
        read_more: 'Ler mais',
        min_read: 'min de leitura',
        updated_label: 'Atualizado',
        published_label: 'Publicado',
        back_to_blog: 'Voltar ao Blog',
        related_posts: 'Artigos relacionados',
        categories: {
            'prompt-guides': 'Guias de prompts',
            'model-reviews': 'Análises de modelos',
            comparisons: 'Comparações',
            workflows: 'Fluxos de trabalho',
        },
        seo: {
            index_title: 'WeryAI Blog | Guias de vídeo e imagem com IA',
            index_description: 'Leia o WeryAI Blog para tutoriais de vídeo e imagem com IA, estruturas de prompts, comparações de modelos e fluxos de produção.',
            index_keywords: 'WeryAI Blog,vídeo IA,imagem IA,guia de prompts,análise de modelos,fluxo de trabalho',
        },
    },
    it: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Guide pratiche per la creazione di immagini e video con IA: prompt, recensioni di modelli e flussi di produzione.',
        hero_badge: 'Insight creativi IA',
        hero_cta_primary: 'Leggi l’articolo in evidenza',
        hero_cta_secondary: 'Sfoglia gli ultimi articoli',
        hero_visual_caption: 'Scelta della settimana',
        featured_hint: 'Recensioni di modelli, modelli di prompt e flussi di produzione',
        featured_posts: 'Articoli in evidenza',
        recent_posts: 'Articoli recenti',
        all_categories: 'Tutte le categorie',
        load_more: 'Carica altri',
        no_posts: 'Non ci sono ancora articoli in questa categoria',
        read_more: 'Leggi di più',
        min_read: 'min di lettura',
        updated_label: 'Aggiornato',
        published_label: 'Pubblicato',
        back_to_blog: 'Torna al Blog',
        related_posts: 'Articoli correlati',
        categories: {
            'prompt-guides': 'Guide ai prompt',
            'model-reviews': 'Recensioni di modelli',
            comparisons: 'Confronti',
            workflows: 'Flussi di lavoro',
        },
        seo: {
            index_title: 'WeryAI Blog | Guide a video e immagini con IA',
            index_description: 'Leggi WeryAI Blog per tutorial su video e immagini con IA, strutture di prompt, confronti tra modelli e flussi di produzione.',
            index_keywords: 'WeryAI Blog,video IA,immagine IA,guida ai prompt,recensione modelli,flusso di lavoro',
        },
    },
    ar: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'أدلة عملية لإنشاء الصور والفيديو بالذكاء الاصطناعي: التوجيهات ومراجعات النماذج وسير العمل.',
        hero_badge: 'رؤى إبداعية بالذكاء الاصطناعي',
        hero_cta_primary: 'اقرأ المقال المميز',
        hero_cta_secondary: 'تصفح أحدث المقالات',
        hero_visual_caption: 'اختيار الأسبوع',
        featured_hint: 'مراجعات النماذج وقوالب التوجيهات وسير العمل',
        featured_posts: 'مقالات مميزة',
        recent_posts: 'أحدث المقالات',
        all_categories: 'جميع الفئات',
        load_more: 'تحميل المزيد',
        no_posts: 'لا توجد مقالات في هذه الفئة بعد',
        read_more: 'اقرأ المزيد',
        min_read: 'دقائق قراءة',
        updated_label: 'تم التحديث',
        published_label: 'نُشر',
        back_to_blog: 'العودة إلى المدونة',
        related_posts: 'مقالات ذات صلة',
        categories: {
            'prompt-guides': 'أدلة التوجيهات',
            'model-reviews': 'مراجعات النماذج',
            comparisons: 'مقارنات',
            workflows: 'سير العمل',
        },
        seo: {
            index_title: 'WeryAI Blog | أدلة فيديو وصور بالذكاء الاصطناعي',
            index_description: 'اقرأ WeryAI Blog للحصول على دروس فيديو وصور بالذكاء الاصطناعي وإطارات التوجيهات ومقارنات النماذج وسير العمل.',
            index_keywords: 'WeryAI Blog,فيديو ذكاء اصطناعي,صورة ذكاء اصطناعي,دليل التوجيهات,مراجعة النماذج,سير العمل',
        },
    },
    th: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'คู่มือการสร้างภาพและวิดีโอด้วย AI: พรอมป์ รีวิวโมเดล และเวิร์กโฟลว์การผลิต',
        hero_badge: 'ข้อมูลเชิงลึกด้านครีเอทีฟ AI',
        hero_cta_primary: 'อ่านบทความแนะนำ',
        hero_cta_secondary: 'ดูบทความล่าสุด',
        hero_visual_caption: 'แนะนำประจำสัปดาห์',
        featured_hint: 'รีวิวโมเดล เทมเพลตพรอมป์ และเวิร์กโฟลว์การผลิต',
        featured_posts: 'บทความแนะนำ',
        recent_posts: 'บทความล่าสุด',
        all_categories: 'ทุกหมวดหมู่',
        load_more: 'โหลดเพิ่ม',
        no_posts: 'ยังไม่มีบทความในหมวดหมู่นี้',
        read_more: 'อ่านเพิ่มเติม',
        min_read: 'นาทีในการอ่าน',
        updated_label: 'อัปเดต',
        published_label: 'เผยแพร่',
        back_to_blog: 'กลับไปที่ Blog',
        related_posts: 'บทความที่เกี่ยวข้อง',
        categories: {
            'prompt-guides': 'คู่มือพรอมป์',
            'model-reviews': 'รีวิวโมเดล',
            comparisons: 'การเปรียบเทียบ',
            workflows: 'เวิร์กโฟลว์',
        },
        seo: {
            index_title: 'WeryAI Blog | คู่มือวิดีโอและภาพ AI',
            index_description: 'อ่าน WeryAI Blog สำหรับบทเรียนวิดีโอและภาพ AI กรอบพรอมป์ การเปรียบเทียบโมเดล และเวิร์กโฟลว์การผลิต',
            index_keywords: 'WeryAI Blog,วิดีโอ AI,ภาพ AI,คู่มือพรอมป์,รีวิวโมเดล,เวิร์กโฟลว์',
        },
    },
    da: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Praktiske guider til AI-billeder og -video: prompts, modelanmeldelser og produktionsworkflows.',
        hero_badge: 'AI kreative indsigter',
        hero_cta_primary: 'Læs udvalgt artikel',
        hero_cta_secondary: 'Se seneste indlæg',
        hero_visual_caption: 'Ugens valg',
        featured_hint: 'Modelanmeldelser, prompt-skabeloner og produktionsguider',
        featured_posts: 'Udvalgte indlæg',
        recent_posts: 'Seneste indlæg',
        all_categories: 'Alle kategorier',
        load_more: 'Indlæs mere',
        no_posts: 'Der er endnu ingen indlæg i denne kategori',
        read_more: 'Læs mere',
        min_read: 'min læsetid',
        updated_label: 'Opdateret',
        published_label: 'Offentliggjort',
        back_to_blog: 'Tilbage til Blog',
        related_posts: 'Relaterede indlæg',
        categories: {
            'prompt-guides': 'Prompt-guider',
            'model-reviews': 'Modelanmeldelser',
            comparisons: 'Sammenligninger',
            workflows: 'Workflows',
        },
        seo: {
            index_title: 'WeryAI Blog | Guider til AI-video og -billeder',
            index_description: 'Læs WeryAI Blog for AI-video- og billedtutorials, prompt-rammer, model sammenligninger og produktionsworkflows.',
            index_keywords: 'WeryAI Blog,AI-video,AI-billede,prompt guide,modelanmeldelse,workflow',
        },
    },
    no: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Praktiske guider for AI-bilder og -video: prompter, modelanmeldelser og produksjonsarbeidsflyt.',
        hero_badge: 'AI kreative innsikter',
        hero_cta_primary: 'Les utvalgt artikkel',
        hero_cta_secondary: 'Se siste innlegg',
        hero_visual_caption: 'Ukens valg',
        featured_hint: 'Modelanmeldelser, prompt-maler og produksjonsguider',
        featured_posts: 'Utvalgte innlegg',
        recent_posts: 'Siste innlegg',
        all_categories: 'Alle kategorier',
        load_more: 'Last inn mer',
        no_posts: 'Det er ingen innlegg i denne kategorien ennå',
        read_more: 'Les mer',
        min_read: 'min lesetid',
        updated_label: 'Oppdatert',
        published_label: 'Publisert',
        back_to_blog: 'Tilbake til Blog',
        related_posts: 'Relaterte innlegg',
        categories: {
            'prompt-guides': 'Prompt-guider',
            'model-reviews': 'Modelanmeldelser',
            comparisons: 'Sammenligninger',
            workflows: 'Arbeidsflyt',
        },
        seo: {
            index_title: 'WeryAI Blog | Guider for AI-video og -bilder',
            index_description: 'Les WeryAI Blog for AI-video- og bildetutorials, prompt-rammer, modellsammenligninger og produksjonsarbeidsflyt.',
            index_keywords: 'WeryAI Blog,AI-video,AI-bilde,prompt guide,modelanmeldelse,arbeidsflyt',
        },
    },
    nl: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Praktische gidsen voor AI-afbeeldingen en -video: prompts, modelbeoordelingen en productieworkflows.',
        hero_badge: 'AI creatieve inzichten',
        hero_cta_primary: 'Lees uitgelicht artikel',
        hero_cta_secondary: 'Bekijk recente berichten',
        hero_visual_caption: 'Keuze van de week',
        featured_hint: 'Modelbeoordelingen, prompt-sjablonen en productiegidsen',
        featured_posts: 'Uitgelichte berichten',
        recent_posts: 'Recente berichten',
        all_categories: 'Alle categorieën',
        load_more: 'Meer laden',
        no_posts: 'Er zijn nog geen berichten in deze categorie',
        read_more: 'Lees meer',
        min_read: 'min leestijd',
        updated_label: 'Bijgewerkt',
        published_label: 'Gepubliceerd',
        back_to_blog: 'Terug naar Blog',
        related_posts: 'Gerelateerde berichten',
        categories: {
            'prompt-guides': 'Prompt-gidsen',
            'model-reviews': 'Modelbeoordelingen',
            comparisons: 'Vergelijkingen',
            workflows: 'Workflows',
        },
        seo: {
            index_title: 'WeryAI Blog | Gidsen voor AI-video en -afbeeldingen',
            index_description: 'Lees WeryAI Blog voor AI-video- en afbeeldingstutorials, prompt-kaders, modelvergelijkingen en productieworkflows.',
            index_keywords: 'WeryAI Blog,AI-video,AI-afbeelding,prompt gids,modelbeoordeling,workflow',
        },
    },
    id: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Panduan praktis untuk pembuatan gambar dan video AI: prompt, ulasan model, dan alur kerja produksi.',
        hero_badge: 'Insight kreatif AI',
        hero_cta_primary: 'Baca artikel unggulan',
        hero_cta_secondary: 'Lihat postingan terbaru',
        hero_visual_caption: 'Pilihan minggu ini',
        featured_hint: 'Ulasan model, templat prompt, dan alur kerja produksi',
        featured_posts: 'Postingan unggulan',
        recent_posts: 'Postingan terbaru',
        all_categories: 'Semua kategori',
        load_more: 'Muat lebih banyak',
        no_posts: 'Belum ada postingan di kategori ini',
        read_more: 'Baca selengkapnya',
        min_read: 'menit baca',
        updated_label: 'Diperbarui',
        published_label: 'Diterbitkan',
        back_to_blog: 'Kembali ke Blog',
        related_posts: 'Postingan terkait',
        categories: {
            'prompt-guides': 'Panduan prompt',
            'model-reviews': 'Ulasan model',
            comparisons: 'Perbandingan',
            workflows: 'Alur kerja',
        },
        seo: {
            index_title: 'WeryAI Blog | Panduan video dan gambar AI',
            index_description: 'Baca WeryAI Blog untuk tutorial video dan gambar AI, kerangka prompt, perbandingan model, dan alur kerja produksi.',
            index_keywords: 'WeryAI Blog,video AI,gambar AI,panduan prompt,ulasan model,alur kerja',
        },
    },
    tr: {
        hero_title: 'WeryAI Blog',
        hero_subtitle: 'Yapay zeka görüntü ve video oluşturma için pratik rehberler: promptlar, model incelemeleri ve üretim akışları.',
        hero_badge: 'Yapay zeka yaratıcı içgörüleri',
        hero_cta_primary: 'Öne çıkan makaleyi oku',
        hero_cta_secondary: 'Son yazıları görüntüle',
        hero_visual_caption: 'Haftanın seçimi',
        featured_hint: 'Model incelemeleri, prompt şablonları ve üretim rehberleri',
        featured_posts: 'Öne çıkan yazılar',
        recent_posts: 'Son yazılar',
        all_categories: 'Tüm kategoriler',
        load_more: 'Daha fazla yükle',
        no_posts: 'Bu kategoride henüz yazı yok',
        read_more: 'Devamını oku',
        min_read: 'dk okuma',
        updated_label: 'Güncellendi',
        published_label: 'Yayınlandı',
        back_to_blog: "Blog'a dön",
        related_posts: 'İlgili yazılar',
        categories: {
            'prompt-guides': 'Prompt rehberleri',
            'model-reviews': 'Model incelemeleri',
            comparisons: 'Karşılaştırmalar',
            workflows: 'İş akışları',
        },
        seo: {
            index_title: 'WeryAI Blog | Yapay zeka video ve görüntü rehberleri',
            index_description: 'Yapay zeka video ve görüntü öğreticileri, prompt çerçeveleri, model karşılaştırmaları ve üretim akışları için WeryAI Blog\'u okuyun.',
            index_keywords: 'WeryAI Blog,yapay zeka video,yapay zeka görüntü,prompt rehberi,model incelemesi,iş akışı',
        },
    },
}

